module.exports = __webpack_public_path__ + "img/BGMain5.9de5c3b5.jpg";